import { useEffect, useState, useRef } from "react";
import { FiChevronDown } from "react-icons/fi";
import { LockIcon, SX_renderpage_tick } from "../../assets/icons";
import "./Dropdown_render.css";

const Dropdown_render = (props) => {
  const {
    label,
    value,
    onChange,
    options,
    isUserPaid = true,
    style,
    customStyle,
    IsUpgradeOpen,
    opensUp = false,
    placeholder = "Select",
    className = "",
  } = props;
  const [isOptionsVisible, setIsOptionsVisible] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!isOptionsVisible) return undefined;

    const handleClickOutside = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setIsOptionsVisible(false);
      }
    };
    const handleKeyDown = (event) => {
      if (event.key === "Escape") setIsOptionsVisible(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOptionsVisible]);

  const handleSelected = (optionValue, index) => {
    if (!isUserPaid && index !== 0) {
      IsUpgradeOpen?.(true);
      setIsOptionsVisible(false);
      return;
    }
    onChange?.(optionValue);
    setIsOptionsVisible(false);
  };

  let displayValue = value;
  const idx = options?.findIndex(
    (opt) =>
      String(opt.value) === String(value) || String(opt.label) === String(value),
  );
  if (idx !== undefined && idx !== -1) displayValue = options[idx].label;

  const isOptionActive = (option) =>
    String(option.value) === String(value) ||
    String(option.label) === String(value);

  const hasValue =
    displayValue !== undefined && displayValue !== null && displayValue !== "";

  return (
    <div className={`render-dd ${className}`.trim()} ref={rootRef} style={style}>
      {label && <span className="DD-label">{label}</span>}

      <button
        type="button"
        className={`render-dd-trigger ${isOptionsVisible ? "is-open" : ""}`}
        onClick={() => setIsOptionsVisible((prev) => !prev)}
        aria-haspopup="listbox"
        aria-expanded={isOptionsVisible}
      >
        <span
          className={hasValue ? "render-dd-value" : "render-dd-placeholder"}
        >
          {hasValue ? displayValue : placeholder}
        </span>
        <FiChevronDown
          className={`render-dd-chevron ${isOptionsVisible ? "is-open" : ""}`}
        />
      </button>

      {isOptionsVisible && (
        <div
          className={`render-dd-menu ${opensUp ? "opens-up" : ""}`}
          role="listbox"
          style={customStyle}
        >
          {options?.map((option, ind) => {
            const isActive = isOptionActive(option);
            const isLocked = !isUserPaid && ind !== 0;
            return (
              <button
                key={`${String(option.value)}-${ind}`}
                type="button"
                role="option"
                aria-selected={isActive}
                className={`render-dd-option ${isActive ? "is-active" : ""} ${
                  isLocked ? "is-locked" : ""
                }`}
                onClick={() => handleSelected(option.value, ind)}
              >
                {/* <img
                  className="render-dd-option-icon"
                  src={isLocked ? LockIcon : SX_renderpage_tick}
                  alt=""
                /> */}
                <span className="render-dd-option-label">{option.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Dropdown_render;
